export function rejectOnResErr(data) {
    return (data === null || data === void 0 ? void 0 : data.res) === "err" ? Promise.reject(data) : data;
}
